import { createFileRoute } from '@tanstack/react-router';
import { ChangePasswordForm } from '../../components/me/ChangePasswordForm';

export const Route = createFileRoute('/_authenticated/_layout/me/security/change-password')({
    component: () => (
        <div className="space-y-4">
            <h1 className="text-2xl font-semibold">Cambiar contraseña</h1>
            <ChangePasswordForm />
        </div>
    ),
});
